import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot} from '@angular/router';
import { SubNavService } from '@core/services';
import { Observable } from 'rxjs';

@Injectable()
export class SubNavGuard implements CanActivate {

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    let urlWithoutParams = null;
    if (state.url.indexOf('?') === -1 ) {
      urlWithoutParams = state.url;
    } else {
      urlWithoutParams = state.url.substring(0, state.url.indexOf('?'));
    }
    const currentRoute = urlWithoutParams.split('/');
    return new Observable<boolean>(observer => {
      this.subNavService.getFormatedSubNav(currentRoute);
      observer.next(true);
      observer.complete();
    });

  }

  constructor(private subNavService: SubNavService) {}
}
